import useSanityData from '~/lib/useSanityData';
import {SanityProductPage} from '~/types/sanityTypes';
import {IconTouch, InternalLink} from '../index';

export default function ProductInStore({
  sanityProduct: serverProduct,
  sanityQuery,
  sanityParams,
}: {
  sanityProduct?: SanityProductPage;
  sanityQuery: string;
  sanityParams: {slug: string};
}) {
  const sanityProduct: SanityProductPage = useSanityData(
    serverProduct,
    sanityQuery,
    sanityParams,
  );

  if (!sanityProduct?.generalInfo?.inStore) {
    return null;
  }

  return (
    <div className="flex flex-col">
      <div className="font-clash uppercase flex flex-row items-center">
        <IconTouch className="inline-block mr-2" />
        Koe tämä tuote myymälässämme
      </div>
      <div className="mt-2">
        Tämä ja yli 1000 tuotetta ovat testattavissa Helsingin myymälässämme.{' '}
        <InternalLink
          documentType="page"
          slug="yhteystiedot"
          className="underline"
        >
          Tule käymään.
        </InternalLink>
      </div>
    </div>
  );
}
